import { useMemo } from "react";
import { Form } from "antd";

import { FormListContext, useFormListParentName } from "./FormListContext";

import type { FormListProps as AntdFormListProps } from "antd/es/form";

interface FormListProps extends Omit<AntdFormListProps, "name"> {
  name: Array<string | number>;
}

export function FormList(props: FormListProps) {
  const parentName = useFormListParentName();

  const contextValue = useMemo(
    () => ({ parentName: parentName.concat(props.name) }),
    [parentName, props.name]
  );

  return (
    <FormListContext value={contextValue}>
      <Form.List {...props} />
    </FormListContext>
  );
}
